export enum AuditTypeEnum {
  BLACKLIST = 'blacklist',
  BROWSE_CONFIGURATION = 'browse_configuration',
  EQUALIZE = 'equalize',
  NEXT_QUERIES = 'next_queries',
  PROMOTION = 'promotion',
  REDIRECTION = 'redirection',
  RELATED_TAGS = 'related_tags',
  SEARCH_CONFIGURATION = 'search_configuration',
  SYNONYM = 'synonym',
  CONFIG = 'config',
  EXPLAIN = 'explain',
}
